import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Says up front that in-app bookings need the Practitioner Booking subscription, so nobody
 * fills out a whole schedule and only finds out when Save is refused.
 */
export const BookingAccessNotice = ({ status, wantsInApp }) => {
  if (!status || status.active || !wantsInApp) return null;
  return (
    <div
      data-testid="booking-subscription-notice"
      style={{
        display: "flex", gap: 10, alignItems: "flex-start",
        border: "1px solid #d9b34a", background: "var(--amber-bg, #fdf6e3)",
        borderRadius: 10, padding: "12px 14px", marginBottom: 18,
      }}
    >
      <AlertTriangle size={16} color="var(--amber, #a67c00)" style={{ marginTop: 2, flexShrink: 0 }} />
      <div style={{ fontSize: 13, lineHeight: 1.6, color: "var(--ink, #263238)" }}>
        <strong>In-app and public bookings need an active Practitioner Booking subscription.</strong>{" "}
        You can set everything up here, but saving is refused until the subscription is active.
        External booking links stay free.
        <div style={{ marginTop: 6 }}>
          <Link
            to="/dashboard/practitioner-hub?tab=subscription"
            style={{ color: "var(--forest, #1a5a44)", fontWeight: 600 }}
            data-testid="booking-subscription-notice-link"
          >
            See the subscription →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookingAccessNotice;
